import {Component} from '@angular/core';
import {AuthService} from "@app/core/services/auth.service";
import {I18nService} from '@app/core/services/i18n.service';
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'LycheeStore';
  public isLoggedIn = false;
  public isSidebarOpen = false;

  constructor(
    private authService: AuthService,
    private readonly i18n: I18nService,
    private router: Router,
  ) {
    authService.isLoggedIn.subscribe((value) => {
      this.isLoggedIn = value;
      void this.i18n.syncWithActivePortal();
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      window.scrollTo(0, 0);
      if (this.isSidebarOpen) {
        this.isSidebarOpen = false;
      }
      void this.i18n.syncWithActivePortal();
    });
  }

  public toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  public closeSidebar() {
    this.isSidebarOpen = false;
  }
}
